import { profile } from "@/data/profile";
import { manifesto } from "@/data/manifesto";
import { socials } from "@/data/socials";
import { MatrixRain } from "@/components/MatrixRain";
import { Hero } from "@/components/Hero";
import { SongOfTheDay } from "@/components/SongOfTheDay";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Socials } from "@/components/Socials";
import { StreamPresetsPromo } from "@/components/StreamPresetsPromo";
import { Footer } from "@/components/Footer";
import { FlashMessage } from "@/components/FlashMessage";


export default function Landing() {


  return (
    <div
      id="top"
      data-testid="landing-page"
      className="relative min-h-screen bg-black grain scanlines"
    >


      <MatrixRain />

      {/* Radial vignette for legibility */}
      <div
        className="pointer-events-none fixed inset-0 z-[1]"
        style={{
          background:
            "radial-gradient(120% 90% at 50% 0%, rgba(0,0,0,0.2), rgba(0,0,0,0.85) 75%)",
        }}
        aria-hidden
      />

      <main className="relative">
        <Hero profile={profile} />
        <SongOfTheDay />
        <Marquee />
        <Manifesto chapters={manifesto} />
        <Socials socials={socials} />
        <StreamPresetsPromo />
      </main>

      <Footer />

      <FlashMessage />

    </div>
  );
}